import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { MessageSquareWarning, ArrowRight } from "lucide-react";

export default function PainPoints() {
  const [data, setData] = useState([]);
  const navigate = useNavigate();
  useEffect(() => { api.get("/pain-points").then((r) => setData(r.data)); }, []);

  return (
    <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
      <div className="mb-8">
        <h1 className="font-display text-3xl sm:text-4xl font-extrabold text-slate-50 flex items-center gap-3"><MessageSquareWarning className="w-8 h-8 text-amber-400" />What Are People Complaining About?</h1>
        <p className="text-slate-400 mt-1">Discover problems first, products second. Real pain points organized by industry.</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {data.map((ind) => (
          <div key={ind.industry} className="glass rounded-xl p-6" data-testid={`painpoint-${ind.industry.toLowerCase().replace(/[^a-z]+/g,'-')}`}>
            <h3 className="font-display text-xl font-bold text-slate-100 mb-4">{ind.industry}</h3>
            <div className="space-y-2">
              {ind.problems.map((p) => (
                <button key={p} onClick={() => navigate(`/discover?search=${encodeURIComponent(ind.industry)}`)}
                  className="w-full flex items-center justify-between text-left px-3 py-2.5 rounded-lg bg-white/5 border border-white/8 hover:border-amber-500/40 group transition-colors">
                  <span className="text-sm text-slate-300 flex items-center gap-2"><span className="text-amber-500">→</span>{p}</span>
                  <ArrowRight className="w-4 h-4 text-slate-600 group-hover:text-amber-400 group-hover:translate-x-0.5 transition-all" />
                </button>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
